import imageCompression from 'browser-image-compression';

/**
 * Compress a single image file.
 * @param {File} file
 * @param {Object} customOptions
 * @returns {Promise<File>}
 */
export const compressImage = async (file, customOptions = {}) => {
    if (!file) throw new Error('No file provided');

    const defaultOptions = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true
    };

    const options = { ...defaultOptions, ...customOptions };

    try {
        const compressedFile = await imageCompression(file, options);
        return compressedFile;
    } catch (err) {
        console.error('Image compression failed:', err);
        return file;
    }
};

/**
 * Compress multiple images.
 * @param {File[]} files
 * @param {Object} customOptions
 * @param {(progress:number,index:number,total:number)=>void} onProgress
 * @returns {Promise<File[]>}
 */
export const compressImages = async (files, customOptions = {}, onProgress) => {
    const compressedFiles = [];

    for (let i = 0; i < files.length; i += 1) {
        const compressed = await compressImage(files[i], customOptions);
        compressedFiles.push(compressed);

        if (onProgress) {
            const percent = Math.round(((i + 1) / files.length) * 100);
            onProgress(percent, i + 1, files.length);
        }
    }

    return compressedFiles;
};
